module.exports = __webpack_public_path__ + "img/rs_logo.a7a92551.png";